// File Metadata:
// Filename: SkillsOverview.js
// Version: 1.00
// Created: 2025-03-28 19:52:50
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useState } from 'react'
import {
    Paper, Typography, Box, Grid,
    Card, CardContent, LinearProgress,
    ToggleButton, ToggleButtonGroup,
    useTheme
} from '@mui/material'
import {
    RadarChart, PolarGrid, PolarAngleAxis,
    PolarRadiusAxis, Radar, ResponsiveContainer
} from 'recharts'

const SkillsOverview = ({ skills, history }) => {
    const [view, setView] = useState('chart')
    const theme = useTheme()

    const skillsByCategory = skills.reduce((acc, skill) => {
        if (!acc[skill.category]) {
            acc[skill.category] = []
        }
        acc[skill.category].push(skill)
        return acc
    }, {})

    const chartData = Object.entries(skillsByCategory).map(([category, skills]) => ({
        category,
        value: skills.reduce((sum, skill) => sum + getLevelValue(skill.level), 0) / skills.length,
        fullMark: 4
    }))

    return (
        <Paper sx={{ p: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h6">Skills Overview</Typography>
                <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={(e, newView) => newView && setView(newView)}
                    size="small"
                >
                    <ToggleButton value="chart">Chart</ToggleButton>
                    <ToggleButton value="list">List</ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {view === 'chart' ? (
                <Box height={300}>
                    <ResponsiveContainer width="100%" height="100%">
                        <RadarChart data={chartData}>
                            <PolarGrid />
                            <PolarAngleAxis dataKey="category" />
                            <PolarRadiusAxis domain={[0, 4]} />
                            <Radar
                                name="Skills"
                                dataKey="value"
                                stroke={theme.palette.primary.main}
                                fill={theme.palette.primary.main}
                                fillOpacity={0.3}
                            />
                        </RadarChart>
                    </ResponsiveContainer>
                </Box>
            ) : (
                <Grid container spacing={2}>
                    {Object.entries(skillsByCategory).map(([category, skills]) => (
                        <Grid item xs={12} md={6} key={category}>
                            <Card variant="outlined">
                                <CardContent>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {category}
                                    </Typography>
                                    {skills.map(skill => (
                                        <Box key={skill.name} mb={1}>
                                            <Box display="flex" justifyContent="space-between">
                                                <Typography variant="body2">{skill.name}</Typography>
                                                <Typography variant="caption" color="textSecondary">
                                                    {skill.level}
                                                </Typography>
                                            </Box>
                                            <LinearProgress
                                                variant="determinate"
                                                value={(getLevelValue(skill.level) / 4) * 100}
                                            />
                                        </Box>
                                    ))}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            )}
        </Paper>
    )
}

const getLevelValue = (level) => {
    const levels = {
        'TRAINEE': 1,
        'QUALIFIED': 2,
        'EXPERT': 3,
        'TRAINER': 4
    }
    return levels[level] || 0
}

export default SkillsOverview
